import { render, staticRenderFns } from "./floating-print-button.vue?vue&type=template&id=835f8310&scoped=true"
import script from "./floating-print-button.vue?vue&type=script&lang=ts"
export * from "./floating-print-button.vue?vue&type=script&lang=ts"
import style0 from "./floating-print-button.vue?vue&type=style&index=0&id=835f8310&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "835f8310",
  null
  
)

export default component.exports